import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router } from '@angular/router';
import { Cargo, CargoService } from '../cargo/cargo.service';
import { MobileService } from './mobile.service';
import { AppConstants, CARGO_STATUS, SERVER } from '../app.constants';
import { CarService } from '../member-kanri/car.service';
import $ from 'jquery';


@Component({
    selector: 'trans-report',
    templateUrl: 'trans-report.component.html',
    providers: [MobileService, CargoService, CarService]
})
export class TransReportComponent implements OnInit {

    CONST: any = AppConstants;
    CARGO_STATUS: any = CARGO_STATUS;

    cargoList: Cargo[];
    totalCount: number;
    currPage: number;

    selectedCargo: Cargo;

    isHistoryPage: boolean = false;
    isListView: boolean = true;

    socket: any;


    constructor(
        private router: Router,
        private cargoService: CargoService,
        private mobileService: MobileService,
        private carService: CarService
    ) {  }
 

    ngOnInit() {
        this.currPage = 1;
        this.isHistoryPage = this.router.url.indexOf('history') > -1;

        if (this.isHistoryPage) {
            this.getTransHistoryList();
        }
        else {            
            this.getTakenCargoList();
        }

        this.socket = new WebSocket(SERVER.socketURL + '/transport/');
    }




    getTakenCargoList() {
        this.mobileService.getTakenCargoList()
        .take(1).subscribe(
            data => {
                this.cargoList = data['results'];
                this.totalCount = data['count'];
            }
        );
    }


    getTransHistoryList() {
        this.mobileService.getTransHistoryList(this.currPage)
        .take(1).subscribe(
            data => {
                this.cargoList = data['results'];
                this.totalCount = data['count'];
            }
        );
    }


    onSelect(cargo: Cargo) {
        this.isListView = false;
        this.selectedCargo = cargo;
    }

    backToList() {
        this.isListView = true;
    }


    cargoReport(status: string) {
        this.cargoService.reportTransStatus(this.selectedCargo.id, status)
        .subscribe(
            data => {
                this.selectedCargo.status = status;
                //send websocket  
                this.socket.send(JSON.stringify({
                    'div': AppConstants.REPORT,
                    'cargo_id': this.selectedCargo.id
                }));
            }
        );
    }


    //ページ移動
    pageChange(page: number) {
        this.currPage = page;
        this.getTransHistoryList();
    }

}



// WEBPACK FOOTER //
// ./src/app/mobile/trans-report.component.ts